import React from "react";
import "./VoteButton.css"; // Import your CSS file for styling
import { useSelector } from "react-redux";

const VoteButton = ({ onClick, voteButtonId }) => {
  const voteState = useSelector((state) => state.userVote);

  const checkIfThisCategoryIsVoted = (currentRestaurantId) => {
    // if (currentRestaurantId === "") return false;
    const filteredArray = voteState.votes.filter(
      (vote) => vote?.["restaurant_id"] === currentRestaurantId
    );

    return filteredArray?.length > 0 ? true : false;
  };

  return (
    // <div
    //   className="delicious100-interactive__votebutton_wrapper"
    //   onClick={onClick}
    // >
    <div
      className="delicious100-interactive__votebutton_outer_rectangle"
      onClick={onClick}
    >
      <div
        className={`delicious100-interactive__votebutton_inner_rectangle ${
          checkIfThisCategoryIsVoted(voteButtonId) ? "active" : ""
        }`}
      >
        <span className="delicious100-interactive__votebutton_vote_button">
          {checkIfThisCategoryIsVoted(voteButtonId) ? "PICKED" : "VOTE"}
        </span>
      </div>
    </div>
    // </div>
  );
};

export default VoteButton;
